/**
 * Google Analytics 4 (gtag.js). Set REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX
 * in `.env.local` (local) or Netlify env (production build).
 */
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();

export function initGoogleAnalytics() {
  if (!MEASUREMENT_ID || typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  document.head.appendChild(script);
}

/** GA4 custom or recommended events (e.g. generate_lead). No-op if GA not configured. */
export function trackGaEvent(eventName, eventParams) {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', eventName, eventParams || {});
}
